import { AnimatePresence } from 'framer-motion';
import { NavbarAdmin } from '../components/navbar/navbarAdmin';

const PrivateLayout = ({ component: Component, ...props }) => {
	return (
		<div className="flex flex-col items-start justify-between bg-black/5 md:flex-row">
			<NavbarAdmin />

			<AnimatePresence>
				<div
					className="relative ml-auto min-h-screen w-full overflow-auto p-5 max-[1309px]:mt-[70px] max-[1309px]:mr-5 md:mr-[30px] md:w-[calc(100%-360px)]"
					id="page-content"
				>
					<Component {...props} />
					{/* <AgoraRTCProvider client={agoraClient} >
						
						<Stick ref={testref} />
						
						</AgoraRTCProvider> */}
					{/* {!location.pathname.includes('/tutor/') && <Support />} */}
				</div>
			</AnimatePresence>
		</div>
	);
};

export { PrivateLayout };
